import { render, staticRenderFns } from "./LgsOrderComp.vue?vue&type=template&id=32dd43bf&scoped=true&"
import script from "./LgsOrderComp.vue?vue&type=script&lang=js&"
export * from "./LgsOrderComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32dd43bf",
  null
  
)

export default component.exports